import { Component } from "react";
import "./App.css";
import Menu from "./components/menu/index";
import Notebook from "./components/notebook/index";
import Dashboard from "./components/experiment/modal/dashboard";
import NavBar from "./components/user_bar/user_bar";
import { topicList } from "./components/data/data";
import { HomePage } from "./components/home_page/home";
import { LoginOK } from "./login";
import Live_layout from "./components/live_bar/live_index";

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      topics: [{ name: "none" }],
      open_topic: [undefined, "World"],
      open_topic_index: "",
      selected: "",
      auth_token: "empty..",
      user: "Guest",
      loggedIn: false,
    };
    this.signOut = this.signOut.bind(this);
  }
  componentDidMount() {
    // fetch('http://localhost:9000/docs')
    console.log(" APP >> Did_Mount", this.state.auth_token);
    // Notebook_data(`Topics`,this.state.auth_token)
    topicList(this.state.user, this.state.auth_token).then((data) => {
      console.log("Notebook", data);
      if (data === undefined) return console.log("No DATA RECEIVED");
      this.setState({ topics: data });
      this.setState({ open_topic: this.state.topics[0] });
      this.setState({ open_topic_index: 0 });
      // console.log("Data4443",this.state.topics,this.state.open_topic);
    });
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    console.log(" APP >> Did_update");
    if (this.state.auth_token !== prevState.auth_token) {
      // this.setState({isSiteLoading:true});
      // console.log(" APP >> Did_update ");
      topicList(this.state.user, this.state.auth_token).then((data) => {
        console.log(" APP >> Did_update >> TopicList");
        if (data === undefined) return console.log("No DATA RECEIVED");
        this.setState({ topics: data });
        this.setState({ open_topic: this.state.topics[0] });
        this.setState({ open_topic_index: 0 });
      });
    }
  }

  updateTopicsAfterAddOrDel = (topic) => {
    if (topic === null) {
      topicList(this.state.user, this.state.auth_token).then((data) => {
        console.log(" APP >> Did_update >> TopicList");
        if (data === undefined) return console.log("No DATA RECEIVED");
        this.setState({ topics: data });
        this.setState({ open_topic: this.state.topics[0] });
        this.setState({ open_topic_index: 0 });
      });
    } else {
      console.log("entered 9963");
      topic = topic[0].toUpperCase() + topic.slice(1);
      topicList(this.state.user, this.state.auth_token).then((data) => {
        console.log(" APP >> Did_update >> TopicList");
        if (data === undefined) return console.log("No DATA RECEIVED");
        this.setState({ topics: data });
        var i;
        for (i in data) {
          if (data[i][1] === topic) {
            this.setState({ open_topic: this.state.topics[i] });
            this.setState({ open_topic_index: i });
          }
        }
        // this.setState({open_topic:this.state.topics[0]});
        // this.setState({open_topic_index: 0 });
      });
    }
  };
  updateTopic = (index) => {
    this.setState({ open_topic: this.state.topics[index] });
    this.setState({ open_topic_index: index });
    console.log("Topic Changed to ", this.state.open_topic);
  };

  auth_info = (token, user) => {
    this.setState({ auth_token: token, user: user });
  };
  loggedIn = (loggedIn) => {
    this.setState({ loggedIn });
  };

  signOut = () => {
    this.setState({
      topics: [{ name: "none" }],
      open_topic: "",
      open_topic_index: "",
      selected: "",
      auth_token: "empty..",
      user: "Guest",
      loggedIn: false,
    });
  };
  render() {
    console.log(" APP >> Render");
    console.log(" APP >> Render >> login : ", this.state);

    let prop = {
      update_topic: this.updateTopic,
      state: this.state,
      update_topic_list: this.updateTopicsAfterAddOrDel,
    };
    return (
      <div className="App">
        <div className="wrapper">
          <header>
            <div className="top-wrapper">
              <NavBar
                data={{
                  auth_info: this.auth_info,
                  signout: this.signOut,
                  loggedIn: this.loggedIn,
                }}
              />
            </div>
          </header>
          <main className="main-wrapper" role="main">
            <section id="Doc-Section">
              {this.state.loggedIn === true ? (
                <>
                  <Menu data={prop} />
                  <div id="docs-main">
                    <Notebook data={prop} />
                    {/* <div id="extra">
                      <Dashboard />
                      <Live_layout />
                    </div> */}
                  </div>
                </>
              ) : (
                <HomePage
                  data={{
                    // auth_info: this.auth_info,
                    // signout: this.signOut,
                    loggedIn: this.loggedIn,
                  }}
                />
              )}
            </section>
          </main>
        </div>
      </div>
    );
  }
}

export default App;
